import { getWebUrl } from "@areahub/config";
import { colors } from "@areahub/theme";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Text,
} from "@chakra-ui/react";
import { Button } from "@ui/components/button/index";
import { Link } from "@ui/components/link/link";
import { Fragment } from "react";
import { useAnalytics } from "@areahub/adapters/src/analytics/analytics.client";
import { LinkWithLabel_T } from "./nav-content";
import {
  IndustriesDropdownMenu,
  IndustriesMenu,
  SolutionsDropdownMenu,
} from "./industries-dropdown-menu";

interface DefaultMobileMenuProps {
  isOpen: boolean;
  mobileLinks: LinkWithLabel_T[];
  onClose(): void;
  onToggle(): void;
}

/* Menu links expand using a drawer */
export const DefaultMobileMenu = ({
  isOpen,
  onClose,
  mobileLinks,
  onToggle,
}: DefaultMobileMenuProps) => {
  const analytics = useAnalytics();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent bg={colors.enterpriseColors.blue["500"]} pb={10}>
        <DrawerCloseButton color={"white"} />
        <DrawerHeader pt={20} color={"white"}></DrawerHeader>

        <DrawerBody bg={colors.enterpriseColors.blue["500"]} color={"white"}>
          <Flex flexDir={"column"} justifyContent={"space-between"} h="full">
            <Flex flexDir={"column"} gap={5} align={"start"}>
              {mobileLinks?.map((link, idx) => (
                <Fragment key={idx}>
                  {link.label === "Resources" ? (
                    <IndustriesDropdownMenu
                      onToggle={onToggle}
                      buttonLabel={
                        link.industriesMenu
                          ?.buttonLabel as IndustriesMenu["buttonLabel"]
                      }
                      industriesMenuItem={
                        link.industriesMenu
                          ?.industriesMenuItem as IndustriesMenu["industriesMenuItem"]
                      }
                    />
                  ) : link.label === "Solutions" ? (
                    <SolutionsDropdownMenu
                      label={link.label}
                      menus={link.industriesMenus as IndustriesMenu[]}
                      onToggle={onToggle}
                    />
                  ) : link.label === "Sign In" ? (
                    <Button
                      __type="AUTH"
                      color={"white"}
                      bg={"none"}
                      fontWeight={"normal"}
                      p={0}
                      h={"auto"}
                      mt={1}
                      label={link.label}
                      _hover={{
                        bg: "none",
                      }}
                    />
                  ) : link.label === "Request a Demo" ? (
                    <Button
                      __type="LINK"
                      href={link.href}
                      width="180px"
                      py={0}
                      color={colors.enterpriseColors.blue["200"]}
                      bg={"white"}
                      textTransform={"uppercase"}
                      label={link.label}
                    />
                  ) : (
                    <Link
                      href={`${getWebUrl() + link.href}`}
                      _hover={{
                        textDecor: "none",
                      }}
                      color={"white"}
                      target={""}
                      onClick={() => {
                        onToggle();
                        analytics.track(
                          "User clicked on a link on the Mobile Nav",
                          {
                            ui: "DefaultMobileMenu",
                            label: link.label,
                            requestedUrl: `${getWebUrl() + link.href}`,
                          },
                        );
                      }}
                    >
                      {link.label}
                    </Link>
                  )}
                </Fragment>
              ))}
            </Flex>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
